import { Outlet } from 'react-router-dom';

import { useExpensesModuleNavigation } from '../hooks/useExpensesModuleNavigation';

export function ExpensesLayout() {
  useExpensesModuleNavigation();

  return (
    <div className="space-y-6">
      <Outlet />
    </div>
  );
}
